/* eslint-disable sort-imports */
import * as Const from 'common/constants'
import type { PhaseInfo } from 'typings'
import { AppDispatch, RootState } from 'store'
import { type CSSProperties } from 'react'
import CommandRowContent from './CommandRowContent'
import NewVersionDialog from 'components/newversiondialog'
import SettingsInfoButton from './SettingsInfoButton'
import { actionCreators } from 'actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withSize } from 'react-sizeme'
import * as Selectors from 'reducers/selectors'

const RowStyle: CSSProperties = {
  alignItems: 'center',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '0px 10px',
  borderTop: '2px solid #303f9f',
  height: '60px',
  position: 'fixed',
  width: '100%',
  bottom: 0,
}

const CommandRow = ({
  currentPhase,
  size,
  finalFormat,
  matchFormat,
  mexicanoCourtSelection,
  resultSorting,
  teamFormat,
  tournamentType,
}: {
  currentPhase: PhaseInfo
  size: { width: number; height: number }
  finalFormat: string
  matchFormat: string
  mexicanoCourtSelection: string
  resultSorting: string
  teamFormat: Const.TeamFormat
  tournamentType: string
}) => {
  const showSettingsInfoButton = currentPhase.phase !== 'settings'

  return (
    <div style={RowStyle}>
      <NewVersionDialog />
      <CommandRowContent phase={currentPhase} width={size.width} />
      {showSettingsInfoButton && (
        <SettingsInfoButton
          finalFormat={finalFormat}
          matchFormat={matchFormat}
          mexicanoCourtSelection={mexicanoCourtSelection}
          resultSorting={resultSorting}
          teamFormat={teamFormat}
          tournamentType={tournamentType}
        />
      )}
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  courts: Selectors.courts(state),
  currentPhase: Selectors.currentPhase(state),
  participants: Selectors.participants(state),
  teamFormat: Selectors.teamFormat(state),
  finalFormat: Selectors.finalFormat(state),
  matchFormat: Selectors.matchFormat(state),
  mexicanoCourtSelection: Selectors.mexicanoCourtSelection(state),
  resultSorting: Selectors.resultSorting(state),
  tournamentType: Selectors.tournamentType(state),
})

const mapDispatchToProps = (dispatch: AppDispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default withSize()(
  connect(mapStateToProps, mapDispatchToProps)(CommandRow)
)
